export const cssData = {
    mfWhite :"--white",
    mfRegular :"--regular",
    mfLight :"--light",
    mfMedium :"--medium",
    mfBold :"--bold",
    mfBlack :"--black",
    mfSemibold :"--semibold",
    mfThin :"--thin",
    mfHeavy :"--heavy",
    mfUltralight :"--ultralight",
    mfRegularNova :"--regularNova",
    mfLightNova :"--lightNova",
    mfSemiboldNova :"--SemiboldNova",
    mfBoxLayoutBg :"--mf-box-layout-bg",
    mfParentTopGap :"--parent-top-gap",
    mfMaxParentheight :"--maxParentheight",
    mfThemeColor :"--mf-theme-color",
    mfThemeColorBright :"--mf-theme-color-bright",
    mfThemeColorDark :"--mf-theme-color-dark",
    mfThemeColorRgb :"--mf-theme-color-rgb",
    mfHeadingBg :"--mf-heading-bg",
    mfThemeColorHightlight :"--mf-theme-color-hightlight",
    mfListHoverBg :"--mf-list-hover-bg",
    mfChatBadgeBg :"--mf-chat-badge-bg",
    mfBgcRecentChatlist :"--mf-bgc-recent-chatlist",
    mfPrimaryDark :"--mf-primary-dark",
    mfSecondaryDark :"--mf-secondary-dark",
    mfSecondaryLight :"--mf-secondary-light",
    mfDangerHightlight :"--mf-danger-hightlight",
    mfChatSubDetails :"--mf-chat-Sub-details",
    mfTextLight :"--mf-text-light",
    mfChatUserGroupName :"--mf-chat-User-group-name",
    mfBorderCommon :"--mf-border-common",
    mfUserStatusSent :"--mf-user-status-sent",
    mfUserStatusReceive :"--mf-user-status-receive",
    mfChatBubbleLinkColor :"--mf-chat-bubble-link-color",
    mfUserStatusSeen :"--mf-user-status-seen",
    mfRecentchatIcon :"--mf-recentchat-icon",
    mfChatBubbleSenderStarIcon :"--mf-chat-bubble-sender-star-icon",
    mfChatBubbleReceiverStarIcon :"--mf-chat-bubble-receiver-star-icon",
    mfChatBubbleReceiverBg :"--mf-chat-bubble-receiver-bg",
    mfChatBubbleReceiverText :"--mf-chat-bubble-receiver-text",
    mfChatBubbleSenderBg :"--mf-chat-bubble-sender-bg",
    mfChatBubbleSenderText :"--mf-chat-bubble-sender-text",
    mfChatBadgeText :"--mf-chat-badge-text",
    mfSearchInputBg :"--mf-search-input-bg",
    mfSearchInputBorder :"--mf-search-input-border",
    mfAttachmentBg :"--mf-attachment-bg",
    mfAttachmentIconBg :"--mf-attachment-icon-bg",
    mfMsgtime :"--mf-msgtime",
    mfSendMessageTime :"--mf-send-message-time",
    mfRevMessageTime :"--mf-rev-message-time",
    mfRecentChatConversionBg :"--mf-recent-chat-conversion-bg",
    mfChatConversionBg :"--mf-chat-conversion-bg",
    mfRecentchatHeaderBg :"--mf-recentchat-header-bg",
    mfConversationHeaderBg :"--mf-conversation-header-bg",
    mfSearchInputIcon :"--mf-search-input-icon",
    mfSearchInputBdr :"--mf-search-input-bdr",
    mfMessageInputbg :"--mf-message-input-bg",
    mfMessageInputBorder :"--mf-message-input-border",
    mfClrTypingArea :"--mf-clr-typing-area",
    mfBgcRecentChatlistHeader :"--mf-bgc-recent-chatlist-header",
    mfMenuName :"--mf-menu-name",
    mfProfileImgName :"--mf-profile-img-name",
    mfBgcUserprofileHeader :"--mf-bgc-userprofile-header",
    mfBgcUserprofilePopup :"--mf-bgc-userprofile-popup",
    mfProfilePopupText :"--mf-profile-popup-text",
    mfIconsContactinfo :"--mf-icons-contactinfo",
    mfIconsDropdownOptions :"--mf-icons-dropdown-options",
    mfIconsRecentchatHeader :"--mf-icons-recentchat-header",
    mfAttachmentDropdownOptions :"--mf-attachment-dropdown-options",
    mfIconsContactinfoDanger :"--mf-icons-contactinfo-danger",
    mfProfileViewIcon :"--mf-profile-view-icon",
    mfChatinputIcons :"--mf-chat-input-icons",
    mfProfilePopupEditicons :"--mf-profile-popup-edit-icons",
    mfOptionActive :"--mf-option-active",
    mfOptionActiveLight :"--mf-option-active-light",
    mfBgHoverCircle :"--mf-bg-hover-circle",
    mfAttachmentColorIcon :"--mf-attachment-color-icon",
    mfBgcStartchatBannerLink :"--mf-bgc-start-chat-banner-link",
    mfContactInfo:"--mf-contact-info",
    mfBgcNewgroup:"--mf-bgc-newgroup",
    mfNewGroupName:"--mf-new-group-name",
    
    //Calls
    mfClrCallMeetingHeading:"--clr-call-meeting-heading",
    mfBgcCallGradient:"--bgc-call-gradient",
    mfBgcCallVideoAudioPinStatus:"--bgc-call-video-audio-pin-status",
    mfBgcCallActionBtnDisabled:"--bgc-call-action-btn-disabled",
    mfBgcCallActionBtnHangup:"--bgc-call-action-btn-hangup",
    mfBgcCallActionBtnHangupHover:"--bgc-call-action-btn-hangup-hover",
    mfBgcCallActionBtnAudioVideo:"--bgc-call-action-btn-audio-video",
    mfClrCallActionBtnAudioVideo:"--clr-call-action-btn-audio-video",
    mfClrCallActionBtnAudioVideoActive:"--clr-call-action-btn-audio-video-active",
    mfBgcCallActionBtnAudioVideoHover:"--bgc-call-action-btn-audio-video-hover",
    mfBgcCallOwnVideo:"--bgc-call-own-video",
    mfBgcCallDefault:"--bgc-call-default",
    mfBgcCallDefaultLight:"--bgc-call-default-light",
    mfBgcCallAvatar:"--bgc-call-avatar",
    mfBgcCallRemoteVideo:"--bgc-call-remote-video",
    mfBgcCallVideoBody:"--bgc-call-video-body",
    mfBgcCallVideoInner:"--bgc-call-video-inner",
    mfBgcCallVideoTag:"--bgc-call-video-tag",
    mfBgcCallScrollTrack:"--bgc-call-scroll-track",
    mfBgcCallParticipantInfoGradient:"--bgc-call-Participant-info-gradient",
    mfClrCallParticipantInfo:"--clr-call-Participant-info",
    mfClrCallParticipantStatusIcon:"--clr-call-participant-status-icon",
    mfClrCallActionIcon:"--clr-call-action-icon",
    mfBgcCallActionAttend:"--bgc-call-action-attend",
    mfBgcCallActionAttendHover:"--bgc-call-action-attend-hover",
    mfClrCallActionAttend:"--clr-call-action-attend",
    mfBgcCallActionBtnGradient:"--bgc-call-action-btn-gradient",
    mfBgcCallOverlayText:"--bgc-call-overlay-text",
    mfBgcVideoFullviewHover:"--bgc-video-fullview-hover",
    mfBgcVideoFullview:"--bgc-video-fullview",
    mfClrVideoFullviewIcon:"--clr-video-fullview-icon",
    mfClrCallToggleAnimation:"--clr-call-toggle-animation",
    mfBgcCallActionBtnAudioVideoDisabled:"--bgc-call-action-btn-audio-video-disabled",
    mfClrCallTopActionIcon:"--clr-call-top-action-icon",
    mfBgcCallParentContainer:"--bgc-call-parent-container"
};
